import { createApp } from 'vue'
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css"
import App from './App.vue'
import router from './router'
import { createPinia, setActivePinia } from 'pinia';

import { install } from "vue3-recaptcha-v2";
import { MainService } from './main.service';
const mainService = new MainService();

async function init() {

  const app = createApp(App);
  const pinia = createPinia();
  setActivePinia(pinia); // ✅ define globalmente
  app.use(pinia);

  const responseConf = await axios.get("https://eomnes-site.s3.us-east-1.amazonaws.com/config.json");
  const bodyConf = responseConf.data.find(item => item.BASE_URL === window.location.origin);
  const productionConfig = bodyConf;
  const developerConfig = {
    SITE_URL_API: process.env.VUE_APP_SITE_URL_API,
    google_recaptcha_key: null
  }
  app.config.globalProperties.$config = productionConfig ?? developerConfig;

  // Busca as configurações do sistema
  const settings = await mainService.findSettings(app.config.globalProperties.$config.SITE_URL_API);

  //Google ReCaptcha - Inicio
  app.use(router)
    .use(install, {
      sitekey: settings.google_recaptcha_key,
      cnDomains: false,  // Opcional. Se você usar na China, defina este valor como true 
    });
  //Google ReCaptcha - Fim


  app.config.errorHandler = (err, instance, info) => {
    console.warn("⚠️ Vue capturou um erro:", err, info);
  };

  app.mount("#app");

  // Salva as configurações do sistema
  const $settingsStore = useSettingsStoreStore();
  settings.site_url_api = "sdfsdfsdf";
  $settingsStore.setSettings(settings);

}

init();

import "bootstrap/dist/js/bootstrap.bundle.min.js"
import { useSettingsStoreStore } from './store/settings';
